import { JSX } from 'react'

import { IconProps } from '../../icon'

const Share: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40.1504 18.2899L33.1943 11.452C32.3502 10.6247 31.1008 10.3883 30.0033 10.8442C28.9059 11.3 28.2137 12.3637 28.2137 13.5456C28.2137 13.7482 28.0786 13.9001 27.8929 13.9339C25.3941 14.2716 20.7004 15.4703 17.3068 19.7756C15.4665 22.1225 14.369 24.9758 14.1158 28.0317C14.0314 29.0279 14.6223 29.9058 15.5509 30.2097C15.7704 30.2773 16.0068 30.3279 16.2262 30.3279C16.9185 30.3279 17.5769 29.9734 17.9821 29.3487C19.0965 27.5928 21.0719 25.3472 24.1953 24.5199C25.3603 24.216 26.5928 24.1485 27.8591 24.2836C28.0448 24.3005 28.1968 24.4693 28.1968 24.6719V25.4823C28.1968 26.5966 28.8046 27.5928 29.8007 28.0993C30.7969 28.6058 31.9618 28.5045 32.8567 27.846L39.8127 22.7303C40.505 22.2238 40.9439 21.4302 40.9946 20.586C41.0452 19.7419 40.7413 18.8977 40.1166 18.2899H40.1504ZM38.327 20.7042L31.3709 25.8369C31.2021 25.9551 31.0332 25.9044 30.9657 25.8706C30.8813 25.8369 30.7462 25.7356 30.7462 25.5161V24.7057C30.7462 23.2199 29.6488 21.9705 28.1799 21.8017C26.5928 21.616 25.0395 21.7173 23.5706 22.1056C20.4809 22.8991 18.3198 24.7901 16.8847 26.5966C17.273 24.6719 18.0835 22.916 19.2991 21.3796C22.1355 17.7665 26.1032 16.7535 28.2305 16.4833C29.6656 16.2976 30.7631 15.0482 30.7631 13.5793C30.7631 13.3598 30.8982 13.2585 30.9995 13.2079C31.0501 13.191 31.1008 13.1741 31.1683 13.1741C31.2527 13.1741 31.3371 13.2079 31.4384 13.2923L38.3945 20.1302C38.5127 20.2484 38.5127 20.3666 38.5127 20.4341C38.5127 20.5016 38.4789 20.6367 38.3439 20.7211L38.327 20.7042Z'
      fill='black'
    />
    <path
      d='M35.5918 30.2604C34.8996 30.2604 34.3255 30.8345 34.3255 31.5267C34.3255 33.6203 32.6203 35.3255 30.5267 35.3255H15.3314C13.2378 35.3255 11.5326 33.6203 11.5326 31.5267V16.3314C11.5326 14.2378 13.2378 12.5326 15.3314 12.5326H22.0848C22.7771 12.5326 23.3511 11.9585 23.3511 11.2663C23.3511 10.574 22.7771 10 22.0848 10H15.3314C11.8365 10 9 12.8365 9 16.3314V31.5267C9 35.0216 11.8365 37.8581 15.3314 37.8581H30.5267C34.0216 37.8581 36.8581 35.0216 36.8581 31.5267C36.8581 30.8345 36.284 30.2604 35.5918 30.2604Z'
      fill='black'
    />
  </svg>
)

export default Share
